/* eslint-disable quote-props */
/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { number, func } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { usePromocao } from '../../contexts/PromocaoContext'
import { isEmptyObject } from '../../utils/helpers/helpers'
import {
  TIPO_DESCONTO_PROMOCAO,
  TIPOS_DESCONTOS_VISUALIZACAO,
} from './constantsPromocao'
import { formatValor } from '../../utils/formatter/formatter'
import { getValorBaseDesconto, sanitizeDiscount, calcularValorTotalPromocao } from './helper/discount'
import { useFluxosPagamento } from '../../contexts/FluxosPagamentoContext'
import { ETAPA_PLANO } from '../../components/FluxosPagamento/constantsFluxosPagamento'

const WrapperInformacaoPromocao = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  padding: 0 5px;

  .info-promocao {
    ${StyleGuide.boldFonte}
    color: ${StyleGuide.cores.cinza600};

    & > small {
      font-size: 10px;
    }
  }

  & p {
    margin: 5px 0;
  }

  & > div  {
    align-items: center;
    display: flex;
    position: relative;

    & > span {
      background-color: ${StyleGuide.cores.cinza300};
      border-radius: 100%;
      cursor: pointer;
      height: 20px;
      margin-left: 5px;
      position: relative;
      width: 20px;

      &:after,
      &:before {
        content: '';
        background-color: ${StyleGuide.cores.branco};
        position: absolute;
        top: 8px;
      }

      &:after {
        height: 10px;
        left: 9px;
        transform: rotate(45deg);
        top: 5px;
        width: 2px;
      }

      &:before {
        height: 2px;
        left: 5px;
        transform: rotate(45deg);
        top: 9px;
        width: 10px;
      }
    }
  }
`

const InformacaoPromocao = ( { freteEntrega, valorPlanoConclusao, setValorDesconto } ) => {
  const { dadosEtapas } = useFluxosPagamento()
  const { codigoPromocao, dadosPromocao, deleteDadosPromocao, errosPromocao } = usePromocao()
  const [ tipoPromocao, setTipoPromocao ] = useState()
  const [ produtoPromocao, setProdutoPromocao ] = useState()
  const [ descricaoPromocao, setDescricaoPromocao ] = useState( '' )

  useEffect( () => {
    if ( !isEmptyObject( dadosPromocao ) ) {
      let valorDesconto = 0
      let tipo = null
      let produto = null
      let isPercentual = false
      let valorPromocao = 0
      let tipoDesconto = null
      const { description } = dadosPromocao

      for ( const beneficio of dadosPromocao.benefits ) {
        isPercentual = beneficio.percentual
        produto = !isEmptyObject( beneficio.produto ) && beneficio.produto.exibicao
        tipo = !isEmptyObject( beneficio ) && beneficio.tipo
        valorPromocao = Object.prototype.hasOwnProperty.call( beneficio, 'valor' ) && beneficio.valor
        tipoDesconto = !isEmptyObject( beneficio.tipoDesconto ) && beneficio.tipoDesconto.codigo

        if ( tipo === TIPO_DESCONTO_PROMOCAO ) {
          const valorBaseDesconto = getValorBaseDesconto( { freteEntrega, tipoDesconto, valorPlanoConclusao } )
          const desconto = sanitizeDiscount( { freteEntrega, isPercentual, tipoDesconto, valorPromocao } )
          valorDesconto += calcularValorTotalPromocao( {
            desconto,
            temPercentual: isPercentual,
            tipoDesconto,
            tipoPlano: dadosEtapas[ ETAPA_PLANO ].tipo,
            valorDescontado: valorBaseDesconto,
            valorPlanoConclusao,
          } )
        }
      }

      const produtoPorTipoDePromocao = tipo === TIPO_DESCONTO_PROMOCAO ? { isPercentual, tipoDesconto, valorDesconto, valorPromocao } : produto

      setTipoPromocao( tipo )
      setProdutoPromocao( produtoPorTipoDePromocao )
      setValorDesconto( valorDesconto )
      setDescricaoPromocao( description || produto )
    } else {
      setTipoPromocao( null )
      setProdutoPromocao( null )
    }
  }, [ dadosPromocao ] )

  if ( errosPromocao === '' && isEmptyObject( dadosPromocao ) ) {
    return null
  }

  const handleDelete = () => {
    setValorDesconto( 0 )
    deleteDadosPromocao( true )
  }

  return (
    <WrapperInformacaoPromocao>
      { Boolean( tipoPromocao && produtoPromocao ) &&
        <>
          <p>{ codigoPromocao }</p>

          <div>
            { tipoPromocao === TIPO_DESCONTO_PROMOCAO && descricaoPromocao === null ?
              <p className="info-promocao">
                <span>
                  { `- ${formatValor( { 'valor': produtoPromocao.valorDesconto } )} ` }
                </span>

                <small>
                  { `${produtoPromocao.isPercentual ? `${produtoPromocao.valorPromocao}%` : ''} (${TIPOS_DESCONTOS_VISUALIZACAO[ produtoPromocao.tipoDesconto ]})` }
                </small>
              </p >
              : (
                <p className="info-promocao">
                  <small>
                    {descricaoPromocao}
                  </small>
                </p>
              ) }

            <span onClick={ () => handleDelete() } />
          </div>
        </>}
    </WrapperInformacaoPromocao>
  )
}

InformacaoPromocao.defaultProps = {
  'setValorDesconto': () => {}
}

InformacaoPromocao.propTypes = {
  'freteEntrega': number.isRequired,
  'setValorDesconto': func,
  'valorPlanoConclusao': number.isRequired
}

export default InformacaoPromocao
